module.exports = __webpack_public_path__ + "static/media/home-red.66677b45.svg";